const personal_info_data = [
  {
    index: 1,
    section_one: [
      {
        index: 1,
        data_type: 'Age',
        data_value: '25',
      },
      {
        index: 2,
        data_type: 'Gender',
        data_value: 'male',
      },
      {
        index: 3,
        data_type: 'Languages',
        data_value: 'Marathi/Hindi/English',
      },
    ],
    section_two: [
      {
        index: 1,
        data_type: 'Phone',
        data_value: '+91-9552483803',
        icon_class: 'fa-solid fa-phone-flip',
        ic_color: '#e64a19',
      },
      {
        index: 2,
        data_type: 'Email',
        data_value: 'prasadsontakke731@gmail.com',
        icon_class: 'fa-solid fa-envelope',
        ic_color: '#00838F',
      },
      {
        index: 3,
        data_type: 'Address',
        data_value: 'Solapur, India - 413306',
        icon_class: 'fa-sharp fa-solid fa-location-dot',
        ic_color: 'rgb(34 119 0)',
      },
    ],
  },
];

export default personal_info_data;
